import { ComponentProps, ReactElement } from 'react';

import InvoiceDetail from '@/features/PdfLayout/layouts/Invoice/InvoicePdfDetail';
import InvoicePdfAddress from '@/features/PdfLayout/layouts/Invoice/InvoicePdfAddress';
import InvoicePdfDetailList from '@/features/PdfLayout/layouts/Invoice/InvoicePdfDetailList';
import { RunPreviewInvoiceResponse } from '@/models/gen/graphql';
import { getClasses } from '@/utils';
import { usePdfLayout } from '@/features/PdfLayout';

export type InvoiceClientProps = ComponentProps<'ul'>;

const InvoiceClient = ({ ...props }: InvoiceClientProps): ReactElement => {
  const { airports, clientName, name, address, cityName, stateCode, zipCode } = usePdfLayout(
    ({ state }: { state: { data: RunPreviewInvoiceResponse } }) => ({
      // Invoice
      airports: state?.data?.output?.airports
        ?.map?.(({ code }) => code) // Get the Airport Code
        ?.filter?.(Boolean) // Filter out falsy values
        ?.join?.(', '), // Join as a string
      // Client override name (try explicit invoice client, then invoice.provider, then payerProvider)
      clientName:
        state?.data?.output?.client?.name ||
        state?.data?.output?.invoice?.provider?.displayName ||
        state?.data?.output?.payerProvider?.name,
      // Payer Provider
      name: state?.data?.output?.payerProvider?.name,
      // Client override address (try explicit invoice client, then payerProvider)
      address: state?.data?.output?.client?.address || state?.data?.output?.payerProvider?.billingAddress,
      cityName: state?.data?.output?.payerProvider?.billingCityCode,
      stateCode: state?.data?.output?.payerProvider?.billingStateCode,
      zipCode: state?.data?.output?.payerProvider?.billingZipCode,
    })
  );

  return (
    <InvoicePdfDetailList {...props} className={getClasses('InvoicePdf-Client', props.className)}>
      <InvoiceDetail bold name="Bill To:" />
      <InvoiceDetail>{clientName ?? name ?? 'N/A'}</InvoiceDetail>
      <InvoicePdfAddress address={address} city={cityName} state={stateCode} zip={zipCode} />
      {airports && <InvoiceDetail name={`${airports.includes(',') ? 'Cities' : 'City'} of Service`}>{airports}</InvoiceDetail>}
    </InvoicePdfDetailList>
  );
};

export default InvoiceClient;
